module.exports = __webpack_public_path__ + "static/img/Goddess of Victory Nikke.d5b0767f.png";